import EntityDetailsMobile from '@/agilis/mobile/EntityDetailsMobile/EntityDetailsMobile.vue'
import TrackerParent from '@/applications/scrum/components/TrackerParent/TrackerParent'

export default {
  name: 'TrackerParentMobile',
  mixins: [TrackerParent],
  components: {
    EntityDetailsMobile
  }
}
